window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs, an) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.AICoach_Robby_Error = function() {
	this.initialize(img.SystemMessageAssets_AICoach_Robby_Error);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,363,238);


(lib.AICoach_Robby_Error_noeyes = function() {
	this.initialize(img.SystemMessageAssets_AICoach_Robby_Error_noeyes);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,732,533);


(lib.armvoor = function() {
	this.initialize(img.SystemMessageAssets_armvoor);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,189,237);


(lib.Robby_headless = function() {
	this.initialize(img.SystemMessageAssets_Robby_headless);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,548,556);


(lib.SystemMessagePopoupSkin_panel = function() {
	this.initialize(img.SystemMessageAssets_SystemMessagePopoupSkin_panel);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,890,644);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.roboPanelHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("rgba(0,0,0,0)").ss(1,1,1).p("EgnDgDyIAAhrMBOHAAAIAABrEAnEAFeIAAAAMhOHAAAIAAAA");
	this.shape.setTransform(0,7.4);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(6,5,2,0.008)").s().p("EAnEAEoMhOHAAAI2bAAIAApPIWbAAMBOHAAAIWbAAIAAJPg");
	this.shape_1.setTransform(0,12.725);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.roboPanelHitarea, new cjs.Rectangle(-393.5,-28.6,787,72), null);


(lib.FallbackBg = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FE9625").ss(3,1,1).p("Eg+6gsWMB91AAAMAAABYtMh91AAAg");
	this.shape.setTransform(-0.025,0);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#333333").s().p("Eg+6AsXMAAAhYtMB91AAAMAAABYtg");
	this.shape_1.setTransform(-0.025,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FallbackBg, new cjs.Rectangle(-404.2,-285.4,808.4,570.8), null);


(lib.eyesRobby = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.AICoach_Robby_Error();
	this.instance.setTransform(-181.5,-119);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-181.5,-119,363,238);


(lib.selectionText = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FE9625").s().p("AkHDLIAAmVIIPAAIAAGVg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.selectionText, new cjs.Rectangle(-26.3,-20.2,52.7,40.5), null);


(lib.haakjeSluiten = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FE9625").s().p("AghCEIAAgXIAqAAIAAjZIgqAAIAAgXIBDAAIAAEHg");
	this.shape.setTransform(9.625,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.haakjeSluiten, new cjs.Rectangle(0,-20.4,20.8,40.9), null);


(lib.haakjeOpenen = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#FE9625").s().p("AghCEIAAkHIBDAAIAAAXIgqAAIAADZIAqAAIAAAXg");
	this.shape.setTransform(-9.625,0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.haakjeOpenen, new cjs.Rectangle(-20.8,-20.4,20.8,40.9), null);


(lib.SystemMessageBackgroundOverlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#EBEAEA").ss(1,0,1).p("EiXjhXfMEvHAAAMAAACu/MkvHAAAg");
	this.shape.setTransform(0.0155,0);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("rgba(0,0,0,0.498)").s().p("EiXjBXgMAAAiu/MEvHAAAMAAACu/g");
	this.shape_1.setTransform(0.0155,0);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SystemMessageBackgroundOverlay, new cjs.Rectangle(-971,-561,1942,1122), null);


(lib.RobbyHead = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.eyesRobby("synched",0);
	this.instance.setTransform(-121.5,-10,1,0.1924);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({startPosition:0},11).to({scaleY:1,y:-24},10).to({scaleY:0.8151},10).to({regX:-0.2,regY:0.1,scaleX:0.9985,scaleY:0.56,skewX:-4.4552,skewY:-1.3547,x:-119.8,y:-6.35},4).to({regX:0,regY:0,scaleX:1,scaleY:0.8151,skewX:0,skewY:0,x:-121.5,y:-24},4).to({regX:-0.1,regY:-0.1,scaleY:0.8989,skewX:0.9863,x:-121.6,y:-32.1},10).wait(11));

	// Layer_2
	this.instance_1 = new lib.AICoach_Robby_Error_noeyes();
	this.instance_1.setTransform(-366,-267);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-366,-267,732,533);


(lib.robby_popup_ani = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_3
	this.instance = new lib.armvoor();
	this.instance.setTransform(155,179);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(60));

	// Layer_2
	this.instance_1 = new lib.RobbyHead("synched",0);
	this.instance_1.setTransform(152.3,28.5,1,1,1.7725,0,0,0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({startPosition:13},13).to({regX:0,regY:0,rotation:4.7387,x:152.2,y:-33.3,startPosition:24},11).to({regX:0.1,regY:0.1,rotation:4.495,x:157,y:30.95,startPosition:35},11).to({regY:0.2,rotation:9.0561,x:177.1,y:6.2,startPosition:46},11).to({regY:0.1,scaleX:0.9999,scaleY:0.9999,rotation:13.8795,x:196.9,y:22.9,startPosition:59},13).wait(1));

	// Layer_1
	this.instance_2 = new lib.Robby_headless();
	this.instance_2.setTransform(-204,90);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(60));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-234.5,-329.6,850.7,975.6);


(lib.Robby_popup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_59 = function() {
		this.stop();
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).wait(59).call(this.frame_59).wait(1));

	// Layer_1
	this.instance = new lib.robby_popup_ani("synched",0);
	this.instance.setTransform(71.9,704.3,0.964,0.964,-9.7051,0,0,-0.1,0.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({regX:0,regY:0,scaleX:1,scaleY:1,rotation:0,x:0,y:0,startPosition:13},13).to({rotation:3.0027,x:10,y:-84.05,startPosition:24},11).to({rotation:-5.1924,x:0,y:94,startPosition:36},12).to({rotation:0,x:2,y:-26.05,startPosition:48},12).to({regX:-0.1,scaleX:0.9999,scaleY:0.9999,rotation:-2.89,x:-34.15,y:-18,startPosition:59},11).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-246.3,-423.1,852.3,1774.3000000000002);


(lib.OkButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// disabllelabelTextfield
	this.disabledLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#060502");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 39;
	this.disabledLabelTextField.lineWidth = 107;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// downLabelTextField
	this.downLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#060502");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 39;
	this.downLabelTextField.lineWidth = 107;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// overLabelTextField
	this.overLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#FE9625");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 39;
	this.overLabelTextField.lineWidth = 107;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(1).to({color:"#060502"},0).wait(3));

	// upLabelTextField
	this.upLabelTextField = new cjs.Text("OK", "28px 'JetBrains Mono'", "#FE9625");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 39;
	this.upLabelTextField.lineWidth = 107;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0,-17.85);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// haakjedynamisch
	this.haakjeOpen = new lib.haakjeOpenen();
	this.haakjeOpen.name = "haakjeOpen";
	this.haakjeOpen.setTransform(-24.05,0.6);

	this.haakjeSluiten = new lib.haakjeSluiten();
	this.haakjeSluiten.name = "haakjeSluiten";
	this.haakjeSluiten.setTransform(24,0.6);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.haakjeSluiten},{t:this.haakjeOpen}]}).wait(4));

	// outline
	this.selectionText = new lib.selectionText();
	this.selectionText.name = "selectionText";
	this.selectionText.setTransform(0,0.4);
	this.selectionText._off = true;

	this.timeline.addTween(cjs.Tween.get(this.selectionText).wait(1).to({_off:false},0).to({_off:true},2).wait(1));

	// hitarea
	this.hitarea = new lib.roboPanelHitarea();
	this.hitarea.name = "hitarea";
	this.hitarea.setTransform(0,-5,0.1945,1);

	this.timeline.addTween(cjs.Tween.get(this.hitarea).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-76.5,-33.1,153.1,71);


(lib.TwoButtonPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button2
	this.button2 = new lib.OkButton();
	this.button2.name = "button2";
	this.button2.setTransform(150,-2.4);

	this.timeline.addTween(cjs.Tween.get(this.button2).wait(1));

	// button1
	this.button1 = new lib.OkButton();
	this.button1.name = "button1";
	this.button1.setTransform(-150,-2.4);

	this.timeline.addTween(cjs.Tween.get(this.button1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TwoButtonPanel, new cjs.Rectangle(-226.5,-35.5,453.1,71), null);


(lib.OneButtonPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Laag_1
	this.button1 = new lib.OkButton();
	this.button1.name = "button1";
	this.button1.setTransform(0,-2.4);

	this.timeline.addTween(cjs.Tween.get(this.button1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.OneButtonPanel, new cjs.Rectangle(-76.5,-35.5,153.1,71), null);


(lib.SystemMessagePanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// headerTextField
	this.headerTextField = new cjs.Text("Hmm, something went wrong...", "30px 'JetBrains Mono'", "#FE9625");
	this.headerTextField.name = "headerTextField";
	this.headerTextField.lineHeight = 40;
	this.headerTextField.lineWidth = 697;
	this.headerTextField.parent = this;
	this.headerTextField.setTransform(-346.55,-234.6);
ranj.TextOffsetFixer.fix(this.headerTextField);

	this.timeline.addTween(cjs.Tween.get(this.headerTextField).wait(1));

	// bodyTextField
	this.bodyTextField = new cjs.Text("Error brrprrtttt error message, abort!\nError brrprrtttt error message, abort!\nError brrprrtttt error message, abort!\nError brrprrtttt error message, abort!\nError brrprrtttt error message, abort!\nError brrprrtttt error message, abort!\nError brrprrtttt error message, abort!\nError brrprrtttt error message, abort!\nError brrprrtttt error message, abort!", "24px 'JetBrains Mono'", "#FE9625");
	this.bodyTextField.name = "bodyTextField";
	this.bodyTextField.lineHeight = 33;
	this.bodyTextField.lineWidth = 697;
	this.bodyTextField.parent = this;
	this.bodyTextField.setTransform(-346.55,-159);
ranj.TextOffsetFixer.fix(this.bodyTextField);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextField).wait(1));

	// buttonPanel1_kopie
	this.buttonPanel2 = new lib.TwoButtonPanel();
	this.buttonPanel2.name = "buttonPanel2";
	this.buttonPanel2.setTransform(0,220.45);

	this.timeline.addTween(cjs.Tween.get(this.buttonPanel2).wait(1));

	// buttonPanel1
	this.buttonPanel1 = new lib.OneButtonPanel();
	this.buttonPanel1.name = "buttonPanel1";
	this.buttonPanel1.setTransform(0,220.45);

	this.timeline.addTween(cjs.Tween.get(this.buttonPanel1).wait(1));

	// bg
	this.instance = new lib.SystemMessagePopoupSkin_panel();
	this.instance.setTransform(-445,-322);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// fallbackBg
	this.fallbackBg = new lib.FallbackBg();
	this.fallbackBg.name = "fallbackBg";
	this.fallbackBg.setTransform(0,-1.95);

	this.timeline.addTween(cjs.Tween.get(this.fallbackBg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SystemMessagePanel, new cjs.Rectangle(-445,-446.8,3009.7,768.8), null);


(lib.SystemMessagePopupSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Robby
	this.robbyPopup = new lib.Robby_popup();
	this.robbyPopup.name = "robbyPopup";
	this.robbyPopup.setTransform(593,135.5);

	this.timeline.addTween(cjs.Tween.get(this.robbyPopup).wait(1));

	// panel
	this.panel = new lib.SystemMessagePanel();
	this.panel.name = "panel";

	this.timeline.addTween(cjs.Tween.get(this.panel).wait(1));

	// overlay
	this.bg = new lib.SystemMessageBackgroundOverlay();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.SystemMessagePopupSkin, new cjs.Rectangle(-970.5,-560.5,2169.6,2047.2), null);


// stage content:
(lib.SystemMessageAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(0,0,0,0);
// library properties:
lib.properties = {
	id: '7D87CBD7B91354468108248D37987D7F',
	width: 1920,
	height: 1080,
	fps: 60,
	color: "#FFFFFF",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/SystemMessageAssets/AICoach_Robby_Error.png", id:"SystemMessageAssets_AICoach_Robby_Error", bundle:"SystemMessageAssets"},
		{src:"assets/skins/images/SystemMessageAssets/AICoach_Robby_Error_noeyes.png", id:"SystemMessageAssets_AICoach_Robby_Error_noeyes", bundle:"SystemMessageAssets"},
		{src:"assets/skins/images/SystemMessageAssets/armvoor.png", id:"SystemMessageAssets_armvoor", bundle:"SystemMessageAssets"},
		{src:"assets/skins/images/SystemMessageAssets/Robby_headless.png", id:"SystemMessageAssets_Robby_headless", bundle:"SystemMessageAssets"},
		{src:"assets/skins/images/SystemMessageAssets/SystemMessagePopoupSkin_panel.png", id:"SystemMessageAssets_SystemMessagePopoupSkin_panel", bundle:"SystemMessageAssets"}
	],
	preloads: []
};



an.handleFilterCache = function(event) {
	if(!event.paused){
		var target = event.target;
		if(target){
			if(target.filterCacheList){
				for(var index = 0; index < target.filterCacheList.length ; index++){
					var cacheInst = target.filterCacheList[index];
					if((cacheInst.startFrame <= target.currentFrame) && (target.currentFrame <= cacheInst.endFrame)){
						cacheInst.instance.cache(cacheInst.x, cacheInst.y, cacheInst.w, cacheInst.h);
					}
				}
			}
		}
	}
}


})(lib.SystemMessageAssets = {}, images, ss, createjs, AdobeAn = AdobeAn||{});
var AdobeAn;
module.exports = lib.SystemMessageAssets;